(function () {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('product-info');
      this.form = this.section.querySelector('[data-product-form]');
      this.formWrapper = (theme.settings.productPageSticky && this.section.querySelector('[data-form-wrapper]')) || this.form;

      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.toggleCartBarOnScroll();

      // The bar contents get swapped on variant change — re-sync state afterwards
      this.observer = new MutationObserver(() => {
        this.syncExpandState();
        this.setCartBarHeight();
      });
      this.observer.observe(this, {childList: true});

      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);
    }

    // The main PDP add-to-cart button is the reveal threshold for the bar
    get scrollTrigger() {
      return this.section.querySelector('[id^="ProductSubmitButton-"]') || this.formWrapper;
    }

    handleClick(event) {
      const expandToggle = event.target.closest('[data-cart-bar-expand]');

      if (expandToggle) {
        event.preventDefault();
        const isExpanded = this.classList.toggle('is-expanded');
        expandToggle.setAttribute('aria-expanded', isExpanded);
        return;
      }

      const addButton = event.target.closest('[data-cart-bar-add-to-cart]');

      if (addButton) {
        event.preventDefault();
        addButton.classList.add('is-loading');
        addButton.setAttribute('disabled', 'disabled');
        this.form.closest('product-form').onSubmitHandler(event);
        return;
      }

      if (event.target.closest('[data-cart-bar-scroll]')) {
        event.preventDefault();
        this.scrollToTop();
      }
    }

    syncExpandState() {
      const expandToggle = this.querySelector('[data-cart-bar-expand]');
      if (expandToggle) {
        expandToggle.setAttribute('aria-expanded', this.classList.contains('is-expanded'));
      }
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector('variant-selects');
      const scrollTarget = theme.isMobile ? variantSelects || this.form : this.section;
      const scrollTop = scrollTarget.getBoundingClientRect().top;

      window.theme.scrollTo(theme.isMobile ? scrollTop - 10 : scrollTop);
    }

    toggleCartBarOnScroll() {
      const trigger = this.scrollTrigger;
      if (!trigger) return;

      // Show only once the main add-to-cart button has been scrolled past,
      // and hide again as soon as the footer enters the viewport
      const passedButton = trigger.getBoundingClientRect().bottom < 0;
      const footer = document.querySelector('.footer-sections');
      const reachedFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;

      this.classList.toggle('is-visible', passedButton && !reachedFooter);
    }

    setCartBarHeight() {
      const cartBarHeight = this.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', `${cartBarHeight}px`);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
    }
  }

  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
})();
